
import React from 'react';
import GrammarPageLayout from '../components/grammar-page-layout';
import GrammarExplanation from './perfect-past-explanation';
const mainimage = '/Images/pastperf1.webp';

const sections = [
  { label: "Grammar", description: "Do this exercise to practice grammar.", type: "quiz", subtype: "perfectpast" },
];

const PerfectPast = () => (
  <GrammarPageLayout
    level="B1"
    title="Perfect Past"
    image={mainimage}
    ExplanationComponent={GrammarExplanation}
    sections={sections}
    seoTitle="Free English Past Perfect Exercises"
    seoDescription="Understand the difference between present perfect and simple past for life experiences vs. finished actions. B1 level practice."
    relatedCategory="grammar-exercises"
    relatedLevel="B1"
  />
);

export default PerfectPast;

